import Query from '../../../../../components/Report';

export const query = ({ prompt_uids, own_domain, competitiors, platforms }) => {
    return new Query('ai-tracking-visibility-overview', {
        prompt_uids: prompt_uids?.length ? setKeywordUids(prompt_uids) : '',
        own_domain: own_domain ? setOwnDomain(own_domain) : '',
        competitiors: competitiors?.length ? setCompetitiorsDomains(competitiors) : '',
        platforms: platforms?.length ? setPlatforms(platforms) : '',
    });
};

function setKeywordUids(ids) {
    return `prompt_uid in (${ids.map((item) => `'${item}'`)})`;
}

function setOwnDomain(own_domain) {
    return `sum(if(REGEXP_REPLACE(base_domain, r'^(www\\.|)', '')=REGEXP_REPLACE('${own_domain}', r'^(www\\.|)', ''),1,0)) ownDomainRankings, sum(if(REGEXP_REPLACE(base_domain, r'^(www\\.|)', '')=REGEXP_REPLACE('${own_domain}', r'^(www\\.|)', ''),score,0)) ownDomainScore,`;
}

function setCompetitiorsDomains(competitiors) {
    return competitiors
        .map(
            (item, index) =>
                `sum(if(REGEXP_REPLACE(base_domain, r'^(www\\.|)', '')=REGEXP_REPLACE('${
                    item.domain
                }', r'^(www\\.|)', ''),1,0)) comp${
                    index + 1
                }Rankings, sum(if(REGEXP_REPLACE(base_domain, r'^(www\\.|)', '')=REGEXP_REPLACE('${
                    item.domain
                }', r'^(www\\.|)', ''),score,0)) comp${index + 1}Score,`,
        )
        .join(' ');
}

function setPlatforms(platforms) {
    return `and platform in (${platforms.map((item) => `'${item}'`)})`;
}
